import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { TrendingUp, DollarSign, Users, Target } from 'lucide-react';
import StaggeredAnimation from '../../components/ui/staggered-animation';

const BusinessOverview = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <StaggeredAnimation delay={100} animation="fadeUp">
        <div>
          <h1 className="text-3xl font-bold text-foreground">🚀 Business Overview</h1>
          <p className="text-muted-foreground">Revenue snapshot, sales KPIs, and quick finance summary</p>
        </div>
      </StaggeredAnimation>

      {/* Key Metrics */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StaggeredAnimation delay={200} animation="fadeUp" stagger={0}>
          <Card className="hover-lift transition-all duration-300 ease-in-out hover:shadow-lg">
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">Total Revenue</CardTitle>
              <DollarSign className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">$45,231.89</div>
              <p className="text-xs text-muted-foreground">
                +20.1% from last month
              </p>
            </CardContent>
          </Card>
        </StaggeredAnimation>

        <StaggeredAnimation delay={200} animation="fadeUp" stagger={100}>
          <Card className="hover-lift transition-all duration-300 ease-in-out hover:shadow-lg">
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">Active Deals</CardTitle>
              <TrendingUp className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">+2350</div>
              <p className="text-xs text-muted-foreground">
                +180.1% from last month
              </p>
            </CardContent>
          </Card>
        </StaggeredAnimation>

        <StaggeredAnimation delay={200} animation="fadeUp" stagger={200}>
          <Card className="hover-lift transition-all duration-300 ease-in-out hover:shadow-lg">
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">Conversion Rate</CardTitle>
              <Target className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">12.5%</div>
              <p className="text-xs text-muted-foreground">
                +19% from last month
              </p>
            </CardContent>
          </Card>
        </StaggeredAnimation>

        <StaggeredAnimation delay={200} animation="fadeUp" stagger={300}>
          <Card className="hover-lift transition-all duration-300 ease-in-out hover:shadow-lg">
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">New Customers</CardTitle>
              <Users className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">+573</div>
              <p className="text-xs text-muted-foreground">
                +201 since last hour
              </p>
            </CardContent>
          </Card>
        </StaggeredAnimation>
      </div>

      {/* Revenue Chart Placeholder */}
      <StaggeredAnimation delay={300} animation="fadeUp">
        <Card>
          <CardHeader>
            <CardTitle>Revenue Overview</CardTitle>
            <CardDescription>Monthly revenue trends and projections</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="h-[300px] flex items-center justify-center bg-muted/20 rounded-lg">
              <p className="text-muted-foreground">Revenue chart will be displayed here...</p>
            </div>
          </CardContent>
        </Card>
      </StaggeredAnimation>

      {/* Quick Actions */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <StaggeredAnimation delay={400} animation="fadeUp" stagger={0}>
          <Card className="hover-lift transition-all duration-300 ease-in-out hover:shadow-lg">
            <CardHeader>
              <CardTitle>Sales Pipeline</CardTitle>
              <CardDescription>Manage deals and leads</CardDescription>
            </CardHeader>
            <CardContent>
              <Button className="w-full">View Pipeline</Button>
            </CardContent>
          </Card>
        </StaggeredAnimation>

        <StaggeredAnimation delay={400} animation="fadeUp" stagger={100}>
          <Card className="hover-lift transition-all duration-300 ease-in-out hover:shadow-lg">
            <CardHeader>
              <CardTitle>Marketing Campaigns</CardTitle>
              <CardDescription>Track campaign performance</CardDescription>
            </CardHeader>
            <CardContent>
              <Button className="w-full">View Campaigns</Button>
            </CardContent>
          </Card>
        </StaggeredAnimation>

        <StaggeredAnimation delay={400} animation="fadeUp" stagger={200}>
          <Card className="hover-lift transition-all duration-300 ease-in-out hover:shadow-lg">
            <CardHeader>
              <CardTitle>Financial Reports</CardTitle>
              <CardDescription>Cashflow and burn rate analysis</CardDescription>
            </CardHeader>
            <CardContent>
              <Button className="w-full">View Reports</Button>
            </CardContent>
          </Card>
        </StaggeredAnimation>
      </div>
    </div>
  );
};

export default BusinessOverview;
